﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDrawingViewField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDrawingViewField, eOutputFieldType.cadDrawingView)
export class CadDrawingViewField extends OutputField implements ICadDrawingViewField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public useCustomScale: boolean;
    public autoPositionAnnotations: boolean;
    public scaleNumerator: number;
    public scaleDenominator: number;
    public autosize: boolean;
    public autoDimension: boolean;
    public autoBalloon: boolean;
    public ignoreMultipleBalloons: boolean;
    public deleted: boolean;
    public suppressed: boolean;
    public autoPosition: boolean;
    public parentBOMtitle: string;
    public bOMrenumber: boolean;
    public customPosition: boolean;
    public x: number;
    public y: number;
}
